<template>
    <div class="lib-accordion">
        <lib-accordion-category
            v-for="(category, index) in categories"
            @clicked="$emit('clicked', $event)"
            :is-selected="isSelected"
            :children="category.children"
            :force-expand="forceExpand"
            :key="category.name">
            <template v-slot:header>
                <slot name="header" :category="category">
                    {{category.name}}
                </slot>
            </template>

            <template v-slot:default="props">
                <slot :item="props.item">
                    {{props.item}}
                </slot>
            </template>

            <template v-slot:action="action">
                <slot name="action"></slot>
            </template>
        </lib-accordion-category>
    </div>
</template>

<script>
import LibAccordionCategory from "./LibAccordionCategory";

export default {
    name: 'LibAccordion',
    components: {LibAccordionCategory},
    props: ['categories', 'isSelected', 'forceExpand'],
    data: function() {
        return {
        };
    },
};
</script>
